export default __webpack_public_path__ + "static/media/globe.c1183ee1.svg";